<template>
  <div>
    <div>
    <div class="remington-typed-font full-height text-align-center">
      <div class="inline-block margin-auto width-90 full-height vertical-middle">
        <nav class="navigationList inline-block">
          <ul>
            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li><!--              <li>|</li>-->
            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
    </div>
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>WRITING AN AFTER ACTION REPORT (AAR)</h1>
    </div>
    <br><br>
    <div class="text-align-left">
      <p>
        After action reports (AARs) are the only compulsory thing in the Flying Tin Cans.
        While we won't hound you to the ends of the earth for not submitting one, we expect that you will in due course.
      <p>
      As with most of the things in FTC, reports are made for historical immersion, and to enhance the feeling of authenticity.
      They are created based on real reports from the era, and much of the information that real pilots had to fill in is also included for you to do so.
      </p>
      <p>
      In essence, your experience of flying in the FTC Campaign, must be complemented by the AAR that you write afterwards.
      </p>
      <h2>What to include in the AAR?</h2>
      <p>
        Your After Action Report must contain an accurate description of the events that transpired in your mission.
      </p>


      <p>
      The AARs that you write and the victories that you claim will be checked by adjutants and commanders.
      You may receive comments and feedback if something is missing or is incorrect.
      </p>
      <p>
        It is important to allow some time for your Adjutants or Squadron Leaders to check your report. It is therefore recommended that you file it as soon after the mission as possible. This has the added benefit of allowing you to accurately recount the events of your mission, before you forget.
      </p>
      Important: Please don’t wait until 5 minutes before the next mission starts with submitting your report. The reports need to be checked and approved by an adjutant or commanding officer. Remember: A report that is not approved is as good as no report. That means you won’t be able to attend a mission if there’s still unapproved reports.
      Please be considerate of the adjutants and commanding officers. They need some time to check and approve the reports and there might be problems or things that have to be corrected. In addition, they are as well busy preparing for the new mission and are glad if everything else is done in good time, so they can concentrate on the mission planning.
      Please contact your adjutant or commanding officer about when he expects your reports to be submitted.
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: "HowToAAR"
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper-tabs.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  /*border-top-left-radius: 15px;*/
  /*border-top-right-radius: 15px;*/
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/info/HowToAAR.vue